export default __webpack_public_path__ + "static/media/testimonials3.0125500a.jpg";